import type { IOrganization, IUser } from 'Model/index.js'
import { OrganizationType } from 'Model/index.js'

export const org1: IOrganization = {
  name: 'Hallo',
  id: '2',
  type: OrganizationType.LABORATORY,
  isPublic: false,
  defaultRedlistMode: 'DE',
  defaultSampleConfigurationType: 'SINGLE_SAMPLE_PAIRS',
  defaultProcessingType: 'METABARCODING',
  isBillingMissing: false
}

export const user1: IUser = {
  id: 'user1',
  firstName: 'Alice',
  lastName: 'Smith',
  email: 'alice.smith@example.com',
  org: org1,
  authServer: ''
}

export const user2: IUser = {
  id: 'user2',
  firstName: 'Bob',
  lastName: 'Johnson',
  email: 'bob.johnson@example.com',
  org: org1,
  authServer: ''
}

export const user3: IUser = {
  id: 'user3',
  firstName: 'Charlie',
  lastName: 'Williams',
  email: 'charlie.williams@example.com',

  authServer: '',
  org: org1
}

export const user4: IUser = {
  id: 'user4',
  firstName: 'Diana',
  lastName: 'Brown',
  email: 'diana.brown@example.com',

  org: org1,
  authServer: ''
}

export const user5: IUser = {
  id: 'user5',
  firstName: 'Ethan',
  lastName: 'Davis',
  email: 'ethan.davis@example.com',

  authServer: '',
  org: org1
}

export const user6: IUser = {
  id: 'user6',
  firstName: 'Fiona',
  lastName: 'Miller',
  email: 'fiona.miller@example.com',

  authServer: '',
  org: org1
}

export const user7: IUser = {
  id: 'user7',
  firstName: 'George',
  lastName: 'Wilson',
  email: 'george.wilson@example.com',

  org: org1,
  authServer: ''
}

export const user8: IUser = {
  id: 'user8',
  firstName: 'Hannah',
  lastName: 'Moore',
  email: 'hannah.moore@example.com',

  org: org1,
  authServer: ''
}

export const user9: IUser = {
  id: 'user9',
  firstName: 'Isaac',
  lastName: 'Taylor',
  email: 'isaac.taylor@example.com',

  org: org1,
  authServer: ''
}

export const user10: IUser = {
  id: 'user10',
  firstName: 'Jasmine',
  lastName: 'Anderson',
  email: 'jasmine.anderson@example.com',

  org: org1,
  authServer: ''
}
